"use client";

import { motion } from "motion/react";
import { container, item } from "@/lib/framer";
import Link from "next/link";
import React from "react";
import { Card, CardContent } from "../ui/card";

export const Testimonial = () => {
  return (
    <section
      id="testimonials"
      className="py-16 md:py-24 relative overflow-hidden"
    >
      {/* <div className="absolute inset-0 opacity-5">
            <div className="absolute -top-24 -left-24 text-9xl text-primary font-serif">"</div>
            <div className="absolute -bottom-24 -right-24 text-9xl text-primary font-serif">"</div>
          </div> */}
      <div className="container mx-auto px-4 relative">
        <motion.div
          className="mb-12 text-center"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          variants={container}
        >
          <motion.h2
            className="text-3xl font-bold tracking-tight sm:text-4xl"
            variants={item}
          >
            What Parents Say
          </motion.h2>
          <motion.p className="mt-4 text-muted-foreground" variants={item}>
            Hear from our school community
          </motion.p>
        </motion.div>

        <motion.div
          className="grid gap-8 md:grid-cols-2 lg:grid-cols-3"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          variants={container}
        >
          {[
            {
              name: "Aarav Sharma",
              role: "Parent of Grade 3 student",
              quote:
                "The teachers at Shree Janakalyan Boarding School are exceptional. My son has developed a love for reading and mathematics that I never expected at such a young age.",
              rating: 5,
            },
            {
              name: "Priya Tamang",
              role: "Parent of Grade 5 student",
              quote:
                "I appreciate how the school balances academic excellence with cultural education. My daughter is learning about our Nepali heritage while also developing global perspectives.",
              rating: 5,
            },
            {
              name: "Rajesh Gurung",
              role: "Parent of Grade 1 student",
              quote:
                "The safe and nurturing environment at Shree Janakalyan Boarding School has made the transition to school life smooth for my child. The staff truly cares about each student's wellbeing.",
              rating: 4,
            },
            {
              name: "Sunita Poudel",
              role: "Parent of Grade 4 student",
              quote:
                "The extracurricular activities offered by the school have helped my daughter discover her talents in art and music. The holistic approach to education is impressive.",
              rating: 5,
            },
            {
              name: "Bikash Thapa",
              role: "Parent of Grade 2 student",
              quote:
                "Communication between teachers and parents is excellent. I always feel informed about my child's progress and any upcoming events or requirements.",
              rating: 5,
            },
            {
              name: "Meena Shrestha",
              role: "Parent of Grade 6 student",
              quote:
                "My son has been at Shree Janakalyan since Grade 1, and the transformation in his confidence and academic abilities has been remarkable. The school truly nurtures potential.",
              rating: 5,
            },
          ]
            .slice(0, 3)
            .map((testimonial, index) => (
              <motion.div key={index} variants={item}>
                <motion.div
                  whileHover={{
                    y: -10,
                    boxShadow:
                      "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                  }}
                  transition={{ type: "spring", stiffness: 400, damping: 10 }}
                >
                  <Card className="h-full">
                    <CardContent className="p-6 flex flex-col h-full">
                      <div className="mb-4 flex items-center gap-4">
                        {/* <div className="relative h-14 w-14 overflow-hidden rounded-full border-2 border-primary/20">
                              <Image
                                src=""
                                alt={testimonial.name}
                                fill
                                className="object-cover"
                              />
                              <User2 />
                            </div> */}
                        <div>
                          <h4 className="font-semibold">{testimonial.name}</h4>
                          <p className="text-sm text-muted-foreground">
                            {testimonial.role}
                          </p>
                          <div className="flex mt-1">
                            {Array.from({ length: 5 }).map((_, i) => (
                              <svg
                                key={i}
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill={
                                  i < testimonial.rating
                                    ? "currentColor"
                                    : "none"
                                }
                                stroke="currentColor"
                                className={`w-4 h-4 ${
                                  i < testimonial.rating
                                    ? "text-yellow-500"
                                    : "text-gray-300"
                                }`}
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                                />
                              </svg>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="flex-1">
                        <p className="italic text-muted-foreground">
                          &quot;{testimonial.quote}&quot;
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </motion.div>
              </motion.div>
            ))}
        </motion.div>

        <motion.div
          className="mt-10 text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Link
            href="/testimonials"
            className="inline-flex items-center text-primary hover:text-primary/80 font-medium"
          >
            View all testimonials
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 ml-1"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
